import * as React from 'react';
export const IcWalking = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 3.68a1 1 0 00-1.27-.63c-2.36.79-4.94-1.72-5-1.76a.81.81 0 00-.29-.19h-.09A.86.86 0 0012 6h-.08a.69.69 0 00-.24.05.42.42 0 00-.14.06.25.25 0 00-.09 0 20.87 20.87 0 00-5.28 5.28 1 1 0 00.28 1.38A.94.94 0 007 13a1 1 0 00.83-.45A18.458 18.458 0 0111 9.05v3.84a13.72 13.72 0 01-4.6 7.31 1 1 0 101.2 1.6 14.83 14.83 0 004.79-6.64 28.18 28.18 0 013.66 6.16A1 1 0 0017 22c.108-.003.216-.02.32-.05a1 1 0 00.68-1.27c-.92-2.75-4.08-6.91-4.95-8V9a6.4 6.4 0 005.32.93A1 1 0 0019 8.68z'
      fill='currentColor'
    />
  </svg>
);
